import type { ReactNode } from 'react'

// 간트 공종 상세창의 공통 카드 컨테이너 — 카드명(+태그) · 본문(이름·전화 등) · 이력평가 줄 · 진행 요약 슬롯.
// 시공파트너·자재파트너·선행공종·메모 카드가 같은 틀을 쓴다. 카드마다 둥근 테두리 상자로 감싸 영역을 나눈다(SIF-2 C-1 시안, 2026-10-29). 이력평가 줄(historySlot)·진행 요약(progressSlot)은
// 후속 작업(WP4·WP5·WP7)이 내용을 얹는 확장 지점이며, 값이 없으면 아무것도 렌더하지 않는다.

interface Props {
  /** 카드명 */
  title: string
  /** 카드명 강조(시공파트너·자재파트너 카드): 더 크고 굵게 */
  emphasis?: boolean
  /** 카드명 옆 태그(예: 자동매칭·직접지정) */
  tag?: ReactNode
  /** 본문 */
  children?: ReactNode
  /** 이력평가 줄 */
  historySlot?: ReactNode
  /** 진행 요약(상태 한 줄·단계 펼침) */
  progressSlot?: ReactNode
}

export function TaskDetailCard({ title, tag, emphasis, children, historySlot, progressSlot }: Props) {
  return (
    <section className="mb-03 rounded-lg border border-border bg-surface-raised p-04">
      <div className="flex items-center gap-1.5 mb-1.5">
        <span
          style={
            emphasis
              ? { fontSize: 'var(--type-heading-sm-size)', fontWeight: 700, color: 'var(--shell-on-surface)', whiteSpace: 'nowrap' }
              : { fontSize: 'var(--type-caption-size)', fontWeight: 600, color: 'var(--shell-on-surface-2)', letterSpacing: '.5px', whiteSpace: 'nowrap' }
          }
        >
          {title}
        </span>
        {tag}
      </div>
      {children}
      {historySlot ? <div className="mt-1.5">{historySlot}</div> : null}
      {progressSlot ? <div className="mt-2">{progressSlot}</div> : null}
    </section>
  )
}
